import { render } from "./edit_dealer.vue?vue&type=template&id=10eb1212&scoped=true"
import script from "./edit_dealer.vue?vue&type=script&lang=js"
export * from "./edit_dealer.vue?vue&type=script&lang=js"

import "./edit_dealer.vue?vue&type=style&index=0&id=10eb1212&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10eb1212"]])

export default __exports__